import { render, staticRenderFns } from "./assignMenuDialog.vue?vue&type=template&id=65e44742&scoped=true&"
import script from "./assignMenuDialog.vue?vue&type=script&lang=js&"
export * from "./assignMenuDialog.vue?vue&type=script&lang=js&"
import style0 from "./assignMenuDialog.vue?vue&type=style&index=0&id=65e44742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e44742",
  null
  
)

export default component.exports